export default __webpack_public_path__ + "static/media/collapse-open-icon.78ef3002.svg";